import { GlobalEventBus } from '@/utils/events/global-event-bus';
import { SnackBarEventArgs } from '@/utils/events/snackbar-eventargs.model';
import { GlobalEvents } from '@/utils/events/global-events.model';
import { DialogEventArgs } from '@/utils/events/dialog-eventargs.model';

export class NotificationHelper {
  static showSnackBar(message: string, duration: number = 5000, color: string = 'primary') {
    GlobalEventBus.$emit(
      GlobalEvents.SnackBar,
      new SnackBarEventArgs({
        message,
        duration,
        color
      })
    );
  }

  static showAlertDialog(title: string, message: string, dialogWidth: number = 500) {
    GlobalEventBus.$emit(
      GlobalEvents.Dialog,
      new DialogEventArgs({
        message,
        title,
        width: dialogWidth
      })
    );
  }

  static showConfirmDialog(dialogEventArgs: DialogEventArgs) {
    GlobalEventBus.$emit(GlobalEvents.Dialog, dialogEventArgs);
  }
}
